
function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/user/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'user')
    }
}

let routes = [
    {
        path: '',
        redirect: '/login',
        meta: {
            title: '登录'
        }
    }, {
        name: 'login',
        path: '/login',
        meta: {
            title: '登录'
        }
    }, {
        name: 'register',
        path: '/register',
        meta: {
            title: '注册'
        }
    },  {
        name: 'syncAccount',
        path: '/syncAccount',
        meta: { // 同步从经营系统过来的账号，让用户去重置密码
            title: '重置密码'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/user.js